import CenteredLoading from './CenteredLoading';
import styled from 'styled-components';

const LoadingOverlay = styled.div`
  position: fixed;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  top: 0;
  user-select: none;
  display: ${props => (props.$active ? 'block' : 'none')};
`;

const GlobalLoader = props => {
  return (
    <>
      {props.children}
      <LoadingOverlay $active={props.loading}>
        <CenteredLoading tip="Loading..." overlay={true} />
      </LoadingOverlay>
    </>
  );
};
GlobalLoader.displayName = 'GlobalLoader';

export default GlobalLoader;
